const SET_PROPERTY = 'SET_PROPERTY_PLAN_PAGE';
const SET_CHECKING_OUT_ID = 'SET_CHECKING_OUT_ID'
const SET_CANCELING_SUBSCRIPTION = 'SET_CANCELING_SUBSCRIPTION';
const SET_REACTIVATING_SUBSCRIPTION = 'SET_REACTIVATING_SUBSCRIPTION';
const SET_PAUSING_SUBSCRIPTION = 'SET_PAUSING_SUBSCRIPTION';
const SET_UNPAUSING_SUBSCRIPTION = 'SET_UNPAUSING_SUBSCRIPTION';
const SET_UPDATING_SUBSCRIPTION_ID = 'SET_UPDATING_SUBSCRIPTION_ID';


export default {
    SET_PROPERTY,
    SET_CHECKING_OUT_ID,
    SET_CANCELING_SUBSCRIPTION,
    SET_REACTIVATING_SUBSCRIPTION,
    SET_PAUSING_SUBSCRIPTION,
    SET_UNPAUSING_SUBSCRIPTION,
    SET_UPDATING_SUBSCRIPTION_ID
}